/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useContext } from 'react';
import { find, last } from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { BrandColors, Label, Text } from '@blend/enterprise-components';

import { convertToDateFormat } from 'blb-utils/date';
import { TitleContext } from './TitleTab';

const styles = StyleSheet.create({
  dateLabel: {
    textAlign: 'left',
    width: '25%',
  },

  datesCard: {
    backgroundColor: 'white',
    border: `1px solid ${BrandColors.CLOUD_30}`,
    borderRadius: 3,
    padding: 30,
  },

  datesTable: {
    width: '100%',
  },
});

const getDateText = (type: keyof typeof Title.Orders.OrderStatusType, orderStatuses?: Title.Orders.OrderStatus[]) => {
  let pastOrder;
  let date;

  switch (type) {
    case 'ORDERED':
      pastOrder = find(orderStatuses, os => os.type === type);
      date = pastOrder?.createdAt;
      return date ? `Ordered on ${convertToDateFormat(date)}` : 'Not yet ordered';
    case 'RECEIVED':
      pastOrder = find(orderStatuses, os => os.type === type);
      date = pastOrder?.createdAt;
      return date ? `Sent on ${convertToDateFormat(date)}` : 'Not yet sent';
    case 'CLEARED':
      pastOrder = last(orderStatuses);
      date = pastOrder?.type === 'CLEARED' ? pastOrder.createdAt : undefined;
      return date ? `Cleared on ${convertToDateFormat(date)}` : 'Not yet cleared';
  }
};

export const DatesCard: React.FC = () => {
  const { order } = useContext(TitleContext);

  return (
    <div className={css(styles.datesCard)}>
      <table className={css(styles.datesTable)}>
        <thead>
          <tr>
            <th className={css(styles.dateLabel)}>
              <Label>Title ordered</Label>
            </th>
            <th className={css(styles.dateLabel)}>
              <Label>Title sent</Label>
            </th>
            <th className={css(styles.dateLabel)}>
              <Label>Title cleared</Label>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Text fontSize="lg" weight="semibold">
                {getDateText('ORDERED', order?.orderStatuses)}
              </Text>
            </td>
            <td>
              <Text fontSize="lg" weight="semibold">
                {getDateText('RECEIVED', order?.orderStatuses)}
              </Text>
            </td>
            <td>
              <Text fontSize="lg" weight="semibold">
                {getDateText('CLEARED', order?.orderStatuses)}
              </Text>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
